import React, { ChangeEvent, FC } from 'react';
import FormInfoTooltip from '../FormInfoTooltip';
import { FormGroup } from '../formInterfaces';
import { NumberInputStyled, FormLabelStyled, RequiredAsteriskStyled, StyledFormControl } from '../styled';

const NumberInputForm: FC<Partial<FormGroup>> = ({ label, placeholder, value, onChange, isOptional, information }) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange?.(e);
    };

    return (
        <StyledFormControl>
            <FormLabelStyled>
                {label}{information && <FormInfoTooltip information={information} />}{isOptional === false && <RequiredAsteriskStyled>*</RequiredAsteriskStyled>}
            </FormLabelStyled>
            <NumberInputStyled
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
                placeholder={placeholder}
                type="number"
                value={value}
            />
        </StyledFormControl>
    );
};

export default NumberInputForm;
